import { api } from '../../../api-helper';
import { URLS } from '../../../../constants/URLS';

export const getInterestsTypes = () => {
  return api.get(URLS.intereststypes, {
    headers: {
      needsToken: true
    }
  });
};

export const getExecuteTypes = () => {
  return api.get(URLS.executetypes, {
    headers: {
      needsToken: true
    }
  });
};

export const bookmarkInterestsTypes = (name, isBookmarked) => {
  return api.put(
    URLS.intereststypes,
    {
      name: name,
      bookmark: isBookmarked
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getChainOfTitleType = () => {
  return api.get(URLS.chainoftitletypes, {
    headers: {
      needsToken: true
    }
  });
};
export const bookmarkChainOfTitleType = (name, isBookmarked) => {
  return api.put(
    URLS.chainoftitletypes,
    {
      name: name,
      bookmark: isBookmarked
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};
export const getLiensType = (productId) => {
  return api.get(URLS.lienstypes, {
    params: {
      productId
    },
    headers: {
      needsToken: true
    }
  });
};
export const bookmarkLiensType = (name, isBookmarked) => {
  return api.put(
    URLS.lienstypes,
    {
      name: name,
      bookmark: isBookmarked
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};
export const getRequirementsType = (productId) => {
  return api.get(URLS.requirementstypes, {
    params: {
      productId
    },
    headers: {
      needsToken: true
    }
  });
};
export const bookmarkRequirementsType = (name, isBookmarked) => {
  return api.put(
    URLS.requirementstypes,
    {
      name: name,
      bookmark: isBookmarked
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};
export const getExceptionsType = (productId) => {
  return api.get(URLS.exceptiontypes, {
    params: {
      productId
    },
    headers: {
      needsToken: true
    }
  });
};
export const bookmarkExceptionsType = (name, isBookmarked) => {
  return api.put(
    URLS.exceptiontypes,
    {
      name: name,
      bookmark: isBookmarked
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getJurisdictionsTypes = () => {
  return api.get(URLS.jurisdictionstypes, {
    headers: {
      needsToken: true
    }
  });
};

export const bookmarkJurisdictionsTypes = (name, isBookmarked) => {
  return api.put(
    URLS.jurisdictionstypes,
    {
      name: name,
      bookmark: isBookmarked
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const saveTypeExamData = (typeExamData) => {
  return api.post(URLS.saveTypeExam, typeExamData, {
    headers: {
      needsToken: true
    }
  });
};

export const updateTypeExamData = (typeExamData) => {
  return api.put(URLS.updateTypeExam, typeExamData, {
    headers: {
      needsToken: true
    }
  });
};

export const getTypeExamDataById = (orderId) => {
  return api.get(`${URLS.typeExam}?id=${orderId}`, {
    headers: {
      needsToken: true
    }
  });
};
